import React, { useState, useEffect } from 'react';
import Avatar from '../../submodule/img/01.jpg';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Link, useParams } from 'react-router-dom';
import RoleModal from '../../components/Modal/RoleModal';

import Swal from 'sweetalert2';
import ActiveList from '../../components/List/Contractor/ContractorDetail/ActiveList';
import ModerationList from '../../components/List/Contractor/ContractorDetail/ModerationList';
import InActiveList from '../../components/List/Contractor/ContractorDetail/InActiveList';
import DeleteList from '../../components/List/Contractor/ContractorDetail/DeleteList';
import { useDispatch, useSelector } from 'react-redux';
import { getUserById } from '../../redux/actions/user/getUserById';
import { allInputs } from '../Moderation/Moderation';
import Input from '../../components/Input/Input';
import { useForm } from 'react-hook-form';

import { getEmployerById } from '../../redux/actions/employer/getEmployerById';
import { resetPasswordUser } from '../../redux/actions/user/resetPasswordUser';
import VacancyTable from '../Vacancies/VacancyTable';
import Skeleton from 'react-loading-skeleton';
import { approveEmployer } from '../../redux/actions/employer/approveEmployer';
import { resetApproveEmployer, resetBlockEmployer, resetGetEmployerById } from '../../redux/slices/employer.slice';
import { blockEmployer } from '../../redux/actions/employer/blockEmployer';
import { updateEmailUser } from '../../redux/actions/user/updateEmailUser';
import { resetGetUserById, resetResetPasswordUser, resetUpdateEmailUser, resetUpdateUser } from '../../redux/slices/user.slice';
import Loading from '../../components/Loading/Loading';
import { findChat } from '../../redux/actions/chat/findChat';
import MessageModal from '../../components/Modal/MessageModal';
import ChatModal from '../Chat/ChatModal';
import { filterVacancy } from '../Vacancies';

function ContractorDetail() {
  const { userId } = useParams();

  const [inputs, setInputs] = useState({
    ie: [
      { type: 'text', required: true, label: 'Наименование', name: 'name' },
      [
        { type: 'number', required: true, label: 'ИНН', name: 'inn' },
        { type: 'email', required: true, label: 'Email', name: 'email' },
      ],
      [
        { type: 'text', required: true, label: 'ОГРНИП', name: 'ogrn' },
        { type: 'phone', required: true, label: 'Телефон', name: 'phone' },
      ],
      { type: 'text', required: true, label: 'Юридический адрес', name: 'legal_address' },
      { type: 'text', required: true, label: 'Адрес места проведения работ', name: 'actual_address' },
    ],
    company: [
      { type: 'text', required: true, label: 'Наименование', name: 'name' },
      { type: 'text', required: true, label: 'Юридический адрес', name: 'legal_address' },
      { type: 'text', required: true, label: 'Адрес места проведения работ', name: 'actual_address' },
      [
        { type: 'text', required: true, label: 'ИНН', name: 'inn' },
        { type: 'text', required: true, label: 'КПП', name: 'kpp' },
      ],
      { type: 'text', required: true, label: 'ОГРН', name: 'ogrn' },
      [
        { type: 'phone', required: true, label: 'Телефон', name: 'phone' },
        { type: 'email', required: true, label: 'Email', name: 'email' },
      ],
    ],
    individual: [
      { type: 'text', required: true, label: 'ФИО', name: 'name' },
      [
        { type: 'text', required: true, label: 'Серия и номер паспорта', name: 'passport' },
        { type: 'date', required: true, label: 'Дата выдачи', name: 'passport_date' },
      ],
      { type: 'text', required: true, label: 'Кем выдан', name: 'passport_issuer' },
      { type: 'text', required: true, label: 'Адрес прописки', name: 'actual_address' },
      [
        { type: 'phone', required: true, label: 'Телефон', name: 'phone' },
        { type: 'email', required: true, label: 'Email', name: 'email' },
      ],
    ],
  });
  const [info, setInfo] = useState(false);
  const [roleState, setRoleState] = useState(false);
  const [userInfo, setUserInfo] = useState([]);
  const dispatch = useDispatch();
  const form = useForm();
  const formVacancy = useForm({
    defaultValues: {
      vacancy: [],
      isShowAction: false,
      tabState: filterVacancy[0],
    },
  });
  const {
    getUserById: { data: getUserByIdData, error: getUserByIdError, loading: getUserByIdLoading },
    resetPasswordUser: { data: resetPasswordUserData, error: resetPasswordUserError, loading: resetPasswordUserLoading },
    updateEmailUser: { data: updateEmailUserData, error: updateEmailUserError, loading: updateEmailUserLoading },
  } = useSelector((state) => state.user);

  const {
    getEmployerById: { data: getEmployerByIdData, error: getEmployerByIdError, loading: getEmployerByIdLoading },
    blockEmployer: { data: blockEmployerData, error: blockEmployerError, loading: blockEmployerLoading },
    approveEmployer: { data: approveEmployerData, error: approveEmployerError, loading: approveEmployerLoading },
  } = useSelector((state) => state.employer);

  const {
    getStats: { data: getStatsData, error: getStatsError, loading: getStatsLoading },
  } = useSelector((state) => state.dashboard);

  useEffect(() => {
    if (blockEmployerData) {
      if (blockEmployerData?.is_blocked) {
        Swal.fire({
          title: 'Учетная запись контрагента перемещена в блок "заблокированные"',
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
        });
      } else {
        Swal.fire({
          title: 'Учетная запись контрагента перемещена в блок "Не активные"',
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
        });
      }
      dispatch(resetBlockEmployer());
      dispatch(getEmployerById(userId));
    }
  }, [blockEmployerData]);

  useEffect(() => {
    if (resetPasswordUserData) {
      Swal.fire({
        title: 'Новый пароль контрагента отправлен на почту',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetResetPasswordUser());
      dispatch(getUserById(getEmployerByIdData?.owner_id));
    }
  }, [resetPasswordUserData]);

  useEffect(() => {
    if (updateEmailUserData) {
      Swal.fire({
        title: 'Логин контрагента успешно изменен',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetUpdateEmailUser());
      dispatch(getUserById(getEmployerByIdData?.owner_id));
    }
  }, [updateEmailUserData]);

  const handleDownload = () => {
    Swal.fire({
      title: 'Файл отправлен!"',
      showConfirmButton: false,
      timer: 1000,
      timerProgressBar: true,
    });
  };

  const handleBlock = () => {
    Swal.fire({
      title: 'Вы действительно хотите заблокировать контрагента?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          blockEmployer({
            id: userId,
            is_blocked: true,
          }),
        );
      }
    });
  };

  useEffect(() => {
    if (approveEmployerData) {
      Swal.fire({
        title: 'Заявка контрагента перемещена в блок Без трансляции',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });

      dispatch(resetApproveEmployer());
      dispatch(getEmployerById(userId));
    }
  }, [approveEmployerData]);

  const handleApprove = () => {
    Swal.fire({
      title: 'Вы действительно хотите переместить заявку в блок Без трансляции?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          approveEmployer({
            id: getEmployerByIdData?.id,
          }),
        );
      }
    });
  };
  const handleResetPassword = () => {
    Swal.fire({
      title: 'Вы действительно хотите сбросить пароль контрагента?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(resetPasswordUser(getUserByIdData?.id));
      }
    });
  };
  const handleUnBlock = () => {
    Swal.fire({
      title: 'Вы действительно хотите разблокировать контрагента?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          blockEmployer({
            id: userId,
            is_blocked: false,
          }),
        );
      }
    });
  };

  const handleModal = () => {
    setRoleState(true);
  };

  const handleInfo = () => {
    setInfo(!info);
  };

  const handleCancel = (data) => {
    setRoleState(data);
  };
  const onSubmit = (data) => {
    Swal.fire({
      title: 'Вы действительно хотите изменить логин контрагента?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          updateEmailUser({
            id: getUserByIdData?.id,
            email: data.email,
          }),
        );
      }
    });
  };
  useEffect(() => {
    if (userId) {
      dispatch(getEmployerById(userId));
    }
    return () => {
      dispatch(resetGetUserById());
      dispatch(resetGetEmployerById());
    };
  }, [userId]);
  useEffect(() => {
    if (getEmployerByIdData) {
      dispatch(getUserById(getEmployerByIdData?.owner_id));
    }
  }, [getEmployerByIdData]);

  useEffect(() => {
    if (getUserByIdData) {
      form.setValue('email', getUserByIdData?.email);
    }
  }, [getUserByIdData]);

  useEffect(() => {
    if (getEmployerByIdData) {
      let { verification, ...otherEmployerData } = getEmployerByIdData;
      let employerData;
      if (getEmployerByIdData?.verification) {
        employerData = getEmployerByIdData?.verification;
      } else {
        employerData = otherEmployerData;
      }
      let userInfoData = [];

      inputs?.[employerData?.type]?.map((item) => {
        if (Array.isArray(item)) {
          item?.map((subitem) => {
            Object.keys(employerData)?.map((key) => {
              if (subitem?.name == key && employerData?.[key]) {
                userInfoData.push({ label: subitem.label, value: employerData?.[key] });
              }
            });
          });
        } else {
          Object.keys(employerData)?.map((key) => {
            if (item?.name == key && employerData?.[key]) {
              userInfoData.push({ label: item.label, value: employerData?.[key] });
            }
          });
        }
      });
      setUserInfo(userInfoData);
    }
  }, [getEmployerByIdData]);
  const isLoading = resetPasswordUserLoading || updateEmailUserLoading || blockEmployerLoading || approveEmployerLoading;
  return (
    <div className="flex flex-1 flex-col w-full mx-auto max-w-[1163px] pb-10">
      {isLoading && <div class="fixed top-0 left-0 bottom-0 right-0 w-[100vw] h-[100vh] z-50"></div>}
      <div className="mx-auto px-6 pt-6 flex flex-col first:flex-row w-full">
        <div className="flex w-full first:w-[20%] justify-center">
          <div className="bg-[#E5E5E5] w-[160px] h-[160px] m-5 flex items-center justify-center rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 24 24">
              <path fill="rgba(0,0,0,0.6)" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
            </svg>
          </div>
        </div>
        <div className="flex w-full first:w-[60%] p-3">
          <div className="flex flex-col justify-start gap-y-3 w-full">
            <p className="text-2xl font-normal">Страница контрагента {getUserByIdData?.email?.split('@')[0]}</p>
            <div className="grid grid-cols-[200px_103px] gap-2 items-center">
              <Input
                form={form}
                name="email"
                placeholder={'Email'}
                rules={{
                  required: { value: true, message: '*Обязательное поле для заполнения' },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Неверный формат почты',
                  },
                }}
                disabled={false}
              />
              <button onClick={form.handleSubmit(onSubmit)} type="button" className="h-[36px] text-center text-[14px] border rounded py-2 px-4 text-white   w-full break-words p-2 xs:w-full hover:bg-[#069488] bg-[#00B2A4]">
                Сохранить
              </button>
            </div>
            <div class="relative w-[320px]">
              <button onClick={handleResetPassword} type="button" className=" text-center text-[14px] border rounded py-2 px-4 text-white    break-words p-2  hover:bg-red-600 bg-red-500 w-[130px]">
                Сброс пароля
              </button>
              {resetPasswordUserLoading && <Loading />}
            </div>

            {/* <p className="text-base font-normal">Телефон: +7 999 999 99 99</p>
                        <p className="text-base font-normal">E-mail: не заполнено</p> */}
            <div className="flex gap-x-5 items-center">
              <button className="flex w-fit text-sm font-normal p-2 bg-[#E5E5E5] border-1 border-[#C4C4C4] rounded-[5px]" onClick={handleInfo}>
                Карточка организации
              </button>
              <button className="flex w-fit text-sm font-normal p-2 bg-[#E5E5E5] border-1 border-[#C4C4C4] rounded-[5px]" onClick={handleModal}>
                Доступ пользователя
              </button>
            </div>
            {info ? (
              <div className="flex flex-col w-full gap-y-1">
                <div className="flex gap-x-1 items-center cursor-pointer" onClick={handleDownload}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.4999 6.5C8.4999 6.36739 8.44722 6.24021 8.35345 6.14645C8.25969 6.05268 8.13251 6 7.9999 6C7.86729 6 7.74011 6.05268 7.64635 6.14645C7.55258 6.24021 7.4999 6.36739 7.4999 6.5V10.293L6.3539 9.146C6.30741 9.09951 6.25222 9.06264 6.19148 9.03748C6.13074 9.01232 6.06564 8.99937 5.9999 8.99937C5.93416 8.99937 5.86906 9.01232 5.80832 9.03748C5.74758 9.06264 5.69239 9.09951 5.6459 9.146C5.59941 9.19249 5.56254 9.24768 5.53738 9.30842C5.51222 9.36916 5.49927 9.43426 5.49927 9.5C5.49927 9.56574 5.51222 9.63084 5.53738 9.69158C5.56254 9.75232 5.59941 9.80751 5.6459 9.854L7.6459 11.854C7.69234 11.9006 7.74752 11.9375 7.80827 11.9627C7.86901 11.9879 7.93413 12.0009 7.9999 12.0009C8.06567 12.0009 8.13079 11.9879 8.19153 11.9627C8.25228 11.9375 8.30745 11.9006 8.3539 11.854L10.3539 9.854C10.4004 9.80751 10.4373 9.75232 10.4624 9.69158C10.4876 9.63084 10.5005 9.56574 10.5005 9.5C10.5005 9.43426 10.4876 9.36916 10.4624 9.30842C10.4373 9.24768 10.4004 9.19249 10.3539 9.146C10.3074 9.09951 10.2522 9.06264 10.1915 9.03748C10.1307 9.01232 10.0656 8.99937 9.9999 8.99937C9.93416 8.99937 9.86906 9.01232 9.80832 9.03748C9.74758 9.06264 9.69239 9.09951 9.6459 9.146L8.4999 10.293V6.5Z"
                      fill="black"
                    />
                    <path
                      d="M14 14V4.5L9.5 0H4C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V14C2 14.5304 2.21071 15.0391 2.58579 15.4142C2.96086 15.7893 3.46957 16 4 16H12C12.5304 16 13.0391 15.7893 13.4142 15.4142C13.7893 15.0391 14 14.5304 14 14ZM9.5 3C9.5 3.39782 9.65804 3.77936 9.93934 4.06066C10.2206 4.34196 10.6022 4.5 11 4.5H13V14C13 14.2652 12.8946 14.5196 12.7071 14.7071C12.5196 14.8946 12.2652 15 12 15H4C3.73478 15 3.48043 14.8946 3.29289 14.7071C3.10536 14.5196 3 14.2652 3 14V2C3 1.73478 3.10536 1.48043 3.29289 1.29289C3.48043 1.10536 3.73478 1 4 1H9.5V3Z"
                      fill="black"
                    />
                  </svg>
                  <span className="text-sm font-normal underline">Выгрузить</span>
                </div>
                {userInfo?.map((item) => (
                  <div className="flex w-full gap-2">
                    <span className="flex break-all w-[50%]">{item?.label}</span>
                    <span className="flex break-all w-[50%]">{item?.value}</span>
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}
            {/* <div className="flex items-center gap-x-2">
              <input type="checkbox" id="agree" className="accent-button text-sm w-4 h-4 mb-2" defaultChecked={getEmployerByIdData?.verification_status} checked={getEmployerByIdData?.verification_status} />
              <label htmlFor="agree" className="block mb-2 text-base text-gray-900">
                согласие с правилами пользования
              </label>
            </div> */}
          </div>
        </div>
        <div className="flex w-full flex-col first:w-[20%] p-3 relative">
          <div className="mb-4">
            <ChatModal employerId={getEmployerByIdData?.id} userType={getUserByIdData?.type} />
            {/* <button type="button" className="text-center text-[14px] border rounded py-2 px-4 text-white  mr-2 w-full break-words p-2 xs:w-full hover:bg-[#069488] bg-[#00B2A4]">
              Написать сообщение
            </button> */}
          </div>

          {!getEmployerByIdData?.is_verified ? (
            <div className="mb-4 relative">
              <button type="button" className="text-center text-[14px] border-1 border-[#00B2A4] rounded py-2 px-4 text-[#00B2A4]  mr-2 w-full break-words p-2 xs:w-full hover:bg-[#00B2A4] hover:text-white bg-white" onClick={handleApprove}>
                Одобрить
              </button>
            </div>
          ) : (
            ''
          )}

          {!getEmployerByIdData?.is_blocked ? (
            <div className="mb-4">
              <button className="text-center text-[14px] py-2 px-4 mr-2 w-full break-words p-2 xs:w-full underline" onClick={handleBlock}>
                Заблокировать
              </button>
            </div>
          ) : (
            <div className="mb-4">
              <button className="text-center text-[14px] py-2 px-4 mr-2 w-full break-words p-2 xs:w-full underline" onClick={handleUnBlock}>
                Разблокировать
              </button>
            </div>
          )}
          {(approveEmployerLoading || blockEmployerLoading) && (
            <div class="translate-y-[10px]">
              <Loading />
            </div>
          )}
        </div>
      </div>
      {!getEmployerByIdLoading && getEmployerByIdData ? (
        <div className="mx-auto px-6 flex flex-col first:flex-row w-full">
          <div className="flex w-full first:w-[20%] mb-2 justify-center"></div>
          <div className="flex flex-col w-full first:w-[80%] mb-2 px-3 gap-y-3">
            <label className="text-2xl font-normal ">Вакансий: {!getStatsLoading && getStatsData ? getStatsData?.total : <Skeleton width="100%" height="200px" className="" style={{ borderRadius: '8px' }} />}</label>
            <VacancyTable employerId={getEmployerByIdData?.id} isAll filter={filterVacancy} form={formVacancy} />
          </div>
        </div>
      ) : (
        <div className="mx-auto px-6 flex flex-col first:flex-row w-full">
          <div className="flex w-full first:w-[20%] mb-2 justify-center"></div>
          <div className="flex flex-col w-full first:w-[80%] mb-2 px-3 gap-y-3 rounded-xl ">
            {' '}
            <Skeleton width="100%" height="200px" className="" style={{ borderRadius: '8px' }} />
          </div>
        </div>
      )}

      <RoleModal open={roleState} sendDataToParent={handleCancel} />
    </div>
  );
}

export default ContractorDetail;
